import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './app';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
